// extracted by mini-css-extract-plugin
module.exports = {"mapContainer":"RestaurantMap_mapContainer__uXjJZ"};